export function getConfig(mode) {
    return {
        cdn: mode === 'staging' ? 'https://connect-sandbox.bolt.com' : 'https://connect.bolt.com',
    }
}
